/**
 * @file
 * A JavaScript file containing the search functionality (small/large screen)
 *
 */

/**
 * Enter Espoo JS.
 */
(function (Drupal, $) {
  Drupal.behaviors.quickSearch = {
    attach: function (context) {
      if (context !== document) {
        return;
      }

      init();
    }
  };

  function init() {
    let wrapper = $('#quick-search');
    let input = wrapper.find('#menu--quick-search--input');
    let submit = wrapper.find('#menu--quick-search--button');
    let icon = $(wrapper).find('#quick-search-icon');

    submit.on("click", function(e) {
      let inputValue = $(input).val();
      triggerSearch(inputValue);
    });

    input.on("keydown", function(e) {
      if (e.keyCode === 13) {
        let inputValue = $(input).val();
        e.preventDefault();
        triggerSearch(inputValue);
        $(wrapper).find('.menu--quick-search--wrapper').css('display', 'flex');
      }
    });

    submit.on("keydown", function(e) {
      if (e.keyCode === 13) {
        let inputValue = $(input).val();
        e.preventDefault();
        triggerSearch(inputValue);
        $(wrapper).find('.menu--quick-search--wrapper').css('display', 'flex');
      }
    });

    $(icon).on("mouseenter focus", function() {
      $(wrapper).attr('aria-expanded', 'true');

      let burger = $('#ee-burger');
      burger.attr('aria-expanded', 'false');
      burger.find('svg.burger-close').addClass('mobile-nav-hidden');
      burger.find('svg.burger-open').removeClass('mobile-nav-hidden');
      $('#main-nav').addClass('mobile-nav-hidden');
    });

    $(wrapper).on("mouseleave focusout", function() {
      $(wrapper).attr('aria-expanded', 'false');
    });

    $(wrapper).on("click", function(e) {
      e.preventDefault();
      focusInside(input);
    });

    $(wrapper).on("keydown", function(e) {
      if (e.keyCode === 13) {
        e.preventDefault();
        $(wrapper).find('.menu--quick-search--wrapper').toggleClass('enabled');
        $(wrapper).attr('aria-expanded', 'true');
        focusInside(input);
      }

      if (e.keyCode === 9) {
        $('body').focusin(function(e) {
          if ($(e.target).parent().is('.menu--quick-search--inner-wrapper') === false) {
            $(wrapper).find('.menu--quick-search--wrapper').removeClass('enabled');
            $(wrapper).attr('aria-expanded', 'false');
          }
        });
      }
    });
  }

  function focusInside(target) {
    $(target).focus();
  }

  function triggerSearch(val) {
    if (window.location.pathname.indexOf('/fi') >= 0) {
      window.location = '/fi/search?search=' + val;
    }
    else {
      window.location = '/search?search=' + val;
    }
  }
})(Drupal, jQuery);
